const pageHidden = () => {
	let pageHiddenProp = null;

	if (typeof document.hidden !== 'undefined') {
		pageHiddenProp = 'hidden';
	} else if (typeof document.msHidden !== 'undefined') {
		pageHiddenProp = 'msHidden';
	} else if (typeof document.webkitHidden !== 'undefined') {
		pageHiddenProp = 'webkitHidden';
	}

	if (!pageHiddenProp) {
		console.warn(
			"A feature which depends on the Page Visibility API can not be used due to the lack of it's support in this browser."
		);
	}

	return pageHiddenProp !== null && document[pageHiddenProp];
};

export const openConversation = (
	{ commit },
	[providerName, conversationId]
) => {
	commit('changeView', 'Conversation');
	commit('ConversationProviders/changeConversation', [
		providerName,
		conversationId
	]);
};
export const closeConversation = ({ commit }) => {
	commit('ConversationProviders/changeConversation', [null, null]);
};

export const newMsg = ({ state, getters }, [conversation, msg]) => {
	let pluginFunctionalityNewMsg = getters.pluginFunctionality('newMsg');

	let strippedConversation = JSON.parse(JSON.stringify(conversation));
	delete strippedConversation.messagekeys;

	const curUser = getters[
		'ConversationProviders/getConversationProviderUser'
	](conversation.providerName);

	for (
		let pluginNameI = 0;
		pluginNameI < pluginFunctionalityNewMsg.length;
		pluginNameI++
	) {
		let pluginName = pluginFunctionalityNewMsg[pluginNameI];
		let plugin = state.plugins[pluginName];

		plugin.worker.postMessage({
			newMsg: {
				curUser,
				conversation: strippedConversation,
				msg
			}
		});
	}
};

export const displayNotification = ({ state }, [pluginName, notification]) => {
	console.log('displayNotification action', pluginName, notification);

	const createNotification = () => {
		if (
			!notification.title ||
			(!notification.showAlways ? !pageHidden() : false)
		) {
			return null;
		}
		const options = Object.assign({}, notification.options);

		return new Notification(notification.title, options);
	};

	if (typeof Notification === 'undefined') {
		console.warn('This browser does not support notifications');
	} else if (Notification.permission === 'granted') {
		createNotification();
	} else if (Notification.permission !== 'denied') {
		Notification.requestPermission().then(permission => {
			if (permission === 'granted') {
				createNotification();
			}
		});
	}
};
